import { autoinject, transient } from "aurelia-framework";

@autoinject()
@transient()
export class VesselComparisonItem {

    public vessel: any = null;

    constructor() { }

    vesselSelected(event: any) {
        if (event.detail.selectedEntity) {
            this.vessel = event.detail.selectedEntity;
        }
    }
}